import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/home.vue";
import SearchListing from "../components/SearchListing.vue";
import ConfirmBooking from "@/components/ConfirmBooking.vue";
import AppTrip from "@/components/AppTrip.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/SearchListing", // URL path
    name: "SearchListing", // route name
    component: SearchListing, // 👈 component used
    // Per-session results page. Its content is driven entirely by the ?data=
    // query payload, so every crafted URL is a distinct page as far as a crawler
    // is concerned. Google indexed such URLs and then flagged the domain under
    // "Deceptive pages" — /SearchListing?data=<blob> was the sample it reported.
    meta: { noindex: true },
  },
  {
    path: "/ConfirmBooking", // URL path
    name: "ConfirmBooking", // route name
    component: ConfirmBooking, // 👈 component used
    meta: { noindex: true },
  },
  {
    path: "/AppTrip", // URL path
    name: "AppTrip", // route name
    component: AppTrip, // 👈 component used
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Emit <meta name="robots" content="noindex, nofollow"> on per-session routes.
//
// This is done here rather than in robots.txt on purpose: a robots.txt Disallow
// stops Google fetching the page, which also stops it ever seeing a noindex, so
// URLs already in the index would stay there. Serving noindex on a crawlable
// page is what actually removes them. (An X-Robots-Tag response header would be
// sturdier than a JS-inserted tag, but mod_headers is not enabled on the host.)
const ROBOTS_META_ID = "route-robots-noindex";

router.afterEach((to) => {
  const existing = document.getElementById(ROBOTS_META_ID);

  if (to.meta?.noindex) {
    if (!existing) {
      const tag = document.createElement("meta");
      tag.id = ROBOTS_META_ID;
      tag.name = "robots";
      tag.content = "noindex, nofollow";
      document.head.appendChild(tag);
    }
  } else if (existing) {
    existing.remove();
  }
});

export default router;
